import type { NavSectionProps } from 'src/components/nav-section';

import { useMemo } from 'react';

import { paths, buildDashboardPath } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';
import { useSigmaDashboards } from 'src/hooks';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------
export const useDynamicNavConfig = (): NavSectionProps['data'] => {
  const { data: dashboards = [], isLoading } = useSigmaDashboards();

  return useMemo<NavSectionProps['data']>(() => {
    const base: NavSectionProps['data'] = [
      {
        items: [
          {
            title: 'Data-Validation',
            path: paths.dashboard.root,
            icon: ICONS.analytics,
            children: [],
          },
        ],
      },
    ];

    if (isLoading) return base;

    base[0].items[0].children = dashboards.map((d) => ({
      title: d.name,
      path: buildDashboardPath(d.slug),
    }));

    return base;
  }, [dashboards, isLoading]);
};
